import React from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";

const UpdatedInfo = props => {
  const updatedAt = useSelector(state =>
    state.deadlinesDetail.subjective
      ? state.deadlinesDetail.subjective.status.updatedAt
      : null);

  return (
    updatedAt && (
      <div className="updateInfo">
        [<FormattedMessage id="deadlines.pages.detail.modifiedDate" />
        {moment(updatedAt).format(DATE_FORMAT_FOR_DISPLAY)}]
      </div>
    )
  );
};

export default UpdatedInfo;
